var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-up-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 186",
    d: "M3.33398 11.3334L8.00065 6.66669L12.6673 11.3334",
    stroke: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 188",
    d: "M8 6.66669V13.6667",
    stroke: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 187",
    d: "M3.33398 7.33335L8.00065 2.66669L12.6673 7.33335",
    stroke: "#FF0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighest);
export default __webpack_public_path__ + "static/media/highest.7e906867aa3e10816ddbbb57719cf657.svg";
export { ForwardRef as ReactComponent };